import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { DASHBOARD_AUTH_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_DASHBOARD_AUTH } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'dashboard',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.INDEX },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "dashboard-auth.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'ViewDashboardAuthLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.INDEX,
        component: (): PromiseVue => import(
          /* webpackChunkName: "dashboard-auth.index" */
          './DashboardAuthIndex.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
